import { queryOptions, useQuery } from "@tanstack/react-query";
import api from "../api";
import type { SiteStatusSite } from "../components/SiteStatus/site-status-types";
import urls from "../urls";
import { queryWithPollResponse } from "../utils/api-utils";

export function siteStatusOverviewQuery(year?: number) {
  return queryOptions({
    queryKey: ["site-status-overview", year],
    queryFn: () => fetchSiteStatusOverview(year),
    refetchInterval: false,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000 // 5 minutes
  });
}

export function useSiteStatusOverview(year?: number) {
  return useQuery(siteStatusOverviewQuery(year));
}

async function fetchSiteStatusOverview(year?: number) {
  const url = year
    ? urls.api.siteStatusOverviewByYear(year)
    : urls.api.siteStatusOverview();

  const response = await queryWithPollResponse(
    () => api.get<Array<SiteStatusSite>>(url),
    {
      queryAgainOnPollSuccess: true
    }
  );
  return response.data || [];
}
